import { keyBy } from 'lodash';
import {
  FieldSection,
  FieldSectionSubType,
  FieldSectionType,
} from 'api/field-sections/types';
import { RbacPermissionRule } from 'api/rbac/rbac-types';
import { Field } from 'api/tasks';
import { FieldSectionMapping } from './section-list';

export const computeSectionFieldMapping = (
  fieldList: Field[],
  fieldSections: FieldSection[] | undefined,
  removeEmptySection = false,
): FieldSectionMapping[] => {
  const fieldMap = keyBy(fieldList, 'fieldId');

  if (!fieldSections) {
    return [];
  }

  return fieldSections.reduce((fieldSectionMap, section) => {
    const fieldsList: Field[] = [];

    if (section.fieldOrder) {
      section.fieldOrder.forEach((fieldId) => {
        if (fieldMap[fieldId]) {
          fieldsList.push(fieldMap[fieldId]);
        }
      });
    }

    if (!removeEmptySection || fieldsList.length > 0) {
      fieldSectionMap.push({
        ...section,
        fieldOrder: fieldsList,
      });
    }

    return fieldSectionMap;
  }, [] as FieldSectionMapping[]);
};

export const getEditRuleForSection = (
  sectionType: FieldSectionType,
  sectionSubType = FieldSectionSubType.Default,
): RbacPermissionRule | undefined => {
  switch (sectionType) {
    case FieldSectionType.Project:
      return 'PROJECT_GROUP_FIELD_SECTION:WRITE';
    case FieldSectionType.Task:
      return 'TASK_GROUP_FIELD_SECTION:WRITE';
    case FieldSectionType.Users:
      if (sectionSubType === FieldSectionSubType.Skill) {
        return 'SKILL_GROUP_FIELD_SECTION:WRITE';
      }
      if (sectionSubType === FieldSectionSubType.ExternalUser) {
        return 'SETTINGS_CUSTOMER_TEAM_MEMBER_FIELD:WRITE';
      }

      return 'SETTINGS_TEAM_MEMBER_FIELD:WRITE';
    case FieldSectionType.Company:
      return 'SETTINGS_CUSTOMER_COMPANY_FIELD:WRITE';
    default:
      return undefined;
  }
};
export const getDeleteRuleForSection = (
  sectionType: FieldSectionType,
  sectionSubType = FieldSectionSubType.Default,
): RbacPermissionRule | undefined => {
  switch (sectionType) {
    case FieldSectionType.Project:
      return 'SETTINGS_PROJECT_FIELD:DELETE';
    case FieldSectionType.Task:
      return 'SETTINGS_TASK_FIELD:DELETE';
    case FieldSectionType.Users:
      if (sectionSubType === FieldSectionSubType.Skill) {
        return 'SETTINGS_SKILL_FIELD:DELETE';
      }
      if (sectionSubType === FieldSectionSubType.ExternalUser) {
        return 'SETTINGS_CUSTOMER_TEAM_MEMBER_FIELD:DELETE';
      }

      return 'SETTINGS_TEAM_MEMBER_FIELD:DELETE';
    case FieldSectionType.Company:
      return 'SETTINGS_CUSTOMER_COMPANY_FIELD:DELETE';

    default:
      return undefined;
  }
};
